import { useQuery } from '@tanstack/react-query'

import { invoicesApi } from '@/features/invoices/api'
import { ApiError } from '@/lib/api/errors'

export const INVOICE_DRAFT_KEY = (id: string) => ['invoices', 'drafts', 'detail', id] as const

/** El borrador ya no existe en Mongo: el TTL de 7 días deslizante venció, o se eliminó
 * desde otra sesión. Es distinto de un fallo de red — solo un 404 permite dar por muerto
 * el borrador y sacar al usuario del editor. */
export function isDraftGoneError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404
}

export const useInvoiceDraft = (id: string | null) =>
  useQuery({
    queryKey: INVOICE_DRAFT_KEY(id ?? ''),
    queryFn: () => invoicesApi.getDraft(id ?? ''),
    enabled: id !== null,
    // Un 404 es definitivo — reintentarlo solo retrasa el aviso al usuario.
    retry: (failureCount, error) => !isDraftGoneError(error) && failureCount < 1,
    // La pestaña del editor puede quedarse abierta días (portátil suspendida, sesión de
    // navegador restaurada al reabrirlo). Revalidar al volver el foco o al reconectar es
    // lo único que detecta que el borrador ya expiró mientras la vista seguía montada.
    // Rehidratar no es un riesgo: `hydratedRef` en InvoiceEditorPage impide que un refetch
    // pise lo que el usuario está capturando.
    refetchInterval: (query) =>
      ['pendiente', 'procesando', 'enviada', 'conciliando'].includes(query.state.data?.status ?? '')
        ? 5000
        : false,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
